import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const sequence = ['Observe', 'Interpret', 'Decide', 'Refine', 'Validate'];
export function FinalCTASection() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-142" data-mp="wemvkwp9d3h">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-143" data-mp="tsdrgu5upj5">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] text-cream-100 sm:text-4xl" data-id="element-144" data-mp="2zejy4fvstyo4">
          Are you ready to stop{' '}
          <em className="not-italic text-gold-400" data-id="element-145" data-mp="39bokafpn9u4x">starting with the mark?</em>
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-cream-100/75 sm:text-lg" data-id="element-146" data-mp="399txswyq5tyq">
          Start organizing your occlusal analysis with a system.
        </p>

        <ol className="mx-auto mt-8 flex w-full max-w-xs flex-col items-center" data-id="element-147" data-mp="2gmr1mbhitvbn">
          {sequence.map((step, index) => <React.Fragment key={step} data-id="element-148" data-mp="2ljrb6wdkxg7i" data-mpi={index}>
              <li className="w-full rounded-xl border border-gold-500/30 bg-navy-800 py-3 text-center text-[14px] font-extrabold uppercase tracking-[0.14em] text-cream-100" data-id="element-149" data-mp="26tzbxxiy6l4p">
                {step}
              </li>
              {index < sequence.length - 1 ? <ArrowDownIcon className="my-1.5 h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-150" data-mp="1s64hocpak8pi" /> : null}
            </React.Fragment>)}
        </ol>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-151" data-mp="1j4wwmwbsd4dd">
          <CTAButton label="I want Occlusion 360™" subline="Just $27 USD · Instant access · 1-year access · 7-day guarantee" data-id="element-152" data-mp="1j7j5czaexpx6" />
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-153" data-mp="198tjywjb5nc6">
          <Countdown tone="dark" data-id="element-154" data-mp="38k4f9h0nzm9l" />
          <p className="mt-4 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-155" data-mp="38j34zerh33sx">
            Limited-time launch price
          </p>
          <div className="mt-4" data-id="element-156" data-mp="11wdvjocclp0q">
            <ScarcityBar tone="dark" data-id="element-157" data-mp="11v2onfnlw15e" />
          </div>
          <p className="mt-3 text-center text-[12px] leading-snug text-cream-100/60" data-id="element-158" data-mp="16mu712wlz0kg">
            Currency conversion is handled automatically according to your country.
          </p>
        </div>
      </div>
    </section>;
}